import Tooltip from '@anm/components/Tooltip';
import getCaps, { allCaps } from '@anm/data/streaming/destinationsCaps';
import noop from '@anm/helpers/noop';
import { useCallback, useState, FC } from 'react';
import { Destination, DestinationKind, WEBINAR } from 'types/stream';

import {
  DestinationBorder,
  DestinationWrapper,
  SocialImage,
  UserImage,
  UserImageContainer,
  WrapperProps
} from './Wrapper';

export { UserImageContainer, SocialImage, DestinationWrapper };

export type SocialAvatarVariant = '30x30' | '50x50';

export type SocialAvatarProps = WrapperProps & {
  alt: string;
  kind?: DestinationKind | null;
  network?: Destination | WEBINAR;
  avatarSrc?: string;
  onAvatarClick?: () => void;
  renderTooltip?(): JSX.Element;
};

const DEFAULT_AVATAR = 'images/user-preview.jpeg';

const pageNetworks = Object.keys(allCaps)
  .filter(k => k.includes('.page'))
  .map(d => d.split('.')[0]);

const SocialAvatarImage: FC<SocialAvatarProps> = ({
  alt,
  kind,
  network,
  avatarSrc = DEFAULT_AVATAR,
  onAvatarClick = noop,
  ...wrapperProps
}) => {
  const [imgSrc, setImgSrc] = useState(avatarSrc);

  const handleOnImageError = useCallback(() => setImgSrc(DEFAULT_AVATAR), []);

  const iconSrc = network ? getCaps(network, kind || (pageNetworks.includes(network) ? 'page' : null))?.iconUrl : '';

  return (
    <UserImageContainer {...wrapperProps} onClick={onAvatarClick}>
      <UserImage src={imgSrc} alt={alt} onError={handleOnImageError} />
      {network && (
        <DestinationWrapper iconHeight={network === 'YOUTUBE' ? 20 : 25}>
          <SocialImage src={iconSrc} alt={`${network}_${kind}`} />
          <DestinationBorder />
        </DestinationWrapper>
      )}
    </UserImageContainer>
  );
};

const SocialAvatar: FC<SocialAvatarProps> = ({ renderTooltip, ...wrapperProps }) => (
  <>
    {renderTooltip ? (
      <Tooltip withArrow variant="black" direction="to-top" renderContent={renderTooltip}>
        <SocialAvatarImage {...wrapperProps} />
      </Tooltip>
    ) : (
      <SocialAvatarImage {...wrapperProps} />
    )}
  </>
);

export default SocialAvatar;
